import { render, staticRenderFns } from "./fs-button-icon.vue?vue&type=template&id=6c2497ac&scoped=true"
import script from "./fs-button-icon.vue?vue&type=script&lang=js"
export * from "./fs-button-icon.vue?vue&type=script&lang=js"
import style0 from "./fs-button-icon.vue?vue&type=style&index=0&id=6c2497ac&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2497ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2497ac')) {
      api.createRecord('6c2497ac', component.options)
    } else {
      api.reload('6c2497ac', component.options)
    }
    module.hot.accept("./fs-button-icon.vue?vue&type=template&id=6c2497ac&scoped=true", function () {
      api.rerender('6c2497ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/fs-button-icon.vue"
export default component.exports